/* eslint-disable */

import React, { useState } from "react";

import { fetchFeedbackPost } from "../../../services/api-raindrop";

import Spacer from "../../../ui-components/spacer/spacer.js";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropInputTextArea from "../../../ui-components/raindrop-input-text-area/raindrop-input-text-area.tsx";
import { Size } from "../../../logic/enums.ts";
import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";
import RaindropTextHeading2 from "../../../ui-components/raindrop-text-heading-2/raindrop-text-heading-2.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";

const RaindropFeedback = () => {
  const [inputText, setInputText] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [hasSubmitted, setHasSubmitted] = useState(false);

  const onSubmitFeedback = () => {
    setIsLoading(true);
    fetchFeedbackPost({
      text: inputText,
      application: "raindrop",
    })
      .then(() => {
        setHasSubmitted(true);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (hasSubmitted) {
    return (
      <div className="flex flex-col h-full items-center w-full justify-center gap-12">
        <i className="fas fa-check-circle text-5xl text-color-raindrop-primary"></i>
        <h1 className="text-xl font-bold">Thank you for your feedback</h1>
        <p className="text-color-text-secondary">
          We appreciate your feedback and will take it into consideration.
        </p>
        <RaindropButton
          title={"Submit more feedback"}
          isPrimary={false}
          onClick={() => setHasSubmitted(false)}
        />
      </div>
    );
  }

  return (
    <RaindropPage hasBackNavigation={true}>
      <FlexCol>
        <RaindropTextHeading2>Help us improve</RaindropTextHeading2>
        <RaindropTextSubtitle>
          Your feedback is extremely valuable to us. We want to hear the good,
          the bad and your suggestions on how we can improve.
        </RaindropTextSubtitle>
      </FlexCol>

      <form className="flex flex-col gap-4 items-end w-full h-full pb-6">
        <RaindropInputTextArea
          onChange={(e) => setInputText(e.target.value)}
          value={inputText}
          example="I would like to see more of this feature..."
        />

        <RaindropButton
          icon="fa-comment"
          title={"Submit Feedback"}
          style={ButtonStyle.Primary}
          size={Size.Large}
          onClick={onSubmitFeedback}
          isLoading={isLoading}
          isFluid={true}
          isDisabled={inputText.length === 0}
        />
      </form>
    </RaindropPage>
  );
};

export default RaindropFeedback;
